export const makeId = () => {
  return (
    'tmp_' +
    Date.now().toString(36) +
    '_' +
    Math.random().toString(36).slice(2, 7)
  );
};
